import React from "react";

interface Props {
    formData: any;
    onChange: (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>) => void;
}

const Guardian: React.FC<Props> = ({ formData, onChange }) => {

    return (
        <>
            <div className="card-tableset" style={{ padding: "10px" }}>
                <div className="card-body">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="row">
                                <div className="col-lg-4">
                                    <label className="form-label">Athlete&apos;s Aadhar</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={12}
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="aadharNo"
                                        placeholder="Enter Athlete's Aadhar"
                                        required
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        value={formData.aadharNo}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian Name</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianName"
                                        required
                                        value={formData.guardianName}
                                        onChange={onChange}
                                        placeholder="Enter Guardian Name" />
                                </div>                                
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian Address</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianAddress"
                                        required
                                        value={formData.guardianAddress}
                                        onChange={onChange}
                                        placeholder="Enter Guardian Address" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian Mobile</label>
                                    <input
                                         type="text"
                                        inputMode="numeric"
                                        maxLength={10}
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianMobile"
                                        required
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        value={formData.guardianMobile}
                                        onChange={onChange}
                                        placeholder="Enter Guardian Mobile" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian Relationship</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianRelationship"
                                        required
                                        value={formData.guardianRelationship}
                                        onChange={onChange}
                                        placeholder="Enter Guardian Relationship" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Guardian&apos;s Aadhar</label>
                                    <input
                                        type="text"
                                        inputMode="numeric"
                                        maxLength={12}
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="guardianAadhar"
                                        placeholder="Enter Guardian's Aadhar"
                                        required
                                        onKeyPress={(e) => {
                                            if (!/[0-9]/.test(e.key)) {
                                                e.preventDefault();
                                            }
                                        }}
                                        value={formData.guardianAadhar}
                                        onChange={onChange}
                                    />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">State</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="state"
                                        required
                                        value={formData.state}
                                        onChange={onChange}
                                        placeholder="Enter State" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">District</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="district"
                                        required
                                        value={formData.district}
                                        onChange={onChange}
                                        placeholder="Enter District" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">City</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="city"
                                        required
                                        value={formData.city}
                                        onChange={onChange}
                                        placeholder="Enter City" />
                                </div>
                                <div className="col-lg-4">
                                    <label className="form-label">Center</label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        style={{ border: "1px solid hsl(0, 0%, 80%)", height: "40px" }}
                                        name="center"
                                        required
                                        value={formData.center}
                                        onChange={onChange}
                                        placeholder="Enter Center" />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default Guardian;